import { matchPath } from 'react-router';
import { VIEW_MODE_FLOW_ROUTE } from '~/constants/client-experience.consts';

export const isViewerMode = () => {
    const { pathname } = window.location;
    return !!matchPath(pathname, VIEW_MODE_FLOW_ROUTE);
};
